import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductPricesDto,
  IProductPricesGetAllParams,
  IProductPricesResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductPricesResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductPricesGetAllParams
>("stores.products.prices");
const postApis = createPostApi<
  IApiResponse<IProductPricesResponse>,
  IPathBaseParam,
  IProductPricesDto
>("stores.products.prices");
const getApis = createGetApi<
  IApiResponse<IProductPricesResponse>,
  IPathByIdParam,
  object
>("stores.products.prices");

const deleteApis = createDeleteApi<
  IApiResponse<IProductPricesResponse>,
  IPathByIdParam
>("stores.products.prices");

export const prices = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...deleteApis,
};
